import { action, observable } from 'mobx';

import Api from '../../api';
import CompanyBillingDetails from '../../domain/entities/CompanyBillingDetails';
import CompanyBillingDetailsFormStore from '../../domain/entities/CompanyBillingDetailsFormStore';
import NotificationsCollection from '../../domain/entities/Notification/NotificationsCollection';

interface ICompanyBillingDetailsRepositoryConfig {
  api: Api;
  notificationsCollection: NotificationsCollection;
}

class CompanyBillingDetailsRepository {
  @observable public isUpdating = false;

  @observable public readonly formStore: CompanyBillingDetailsFormStore;

  @observable notificationsCollection: NotificationsCollection;

  public api: Api;

  constructor(config: ICompanyBillingDetailsRepositoryConfig) {
    this.api = config.api;
    this.notificationsCollection = config.notificationsCollection;

    this.formStore = new CompanyBillingDetailsFormStore();
  }

  @action
  private setIsUpdating(isUpdating: boolean): void {
    this.isUpdating = isUpdating;
  }

  @action
  async updateCompanyBillingDetails(
    companyBillingDetails: CompanyBillingDetails,
  ): Promise<CompanyBillingDetails> {
    this.setIsUpdating(true);
    const companyBillingData = companyBillingDetails.toJSON();
    const response = await this.api.updateCompanyBillingDetails(
      companyBillingData,
    );
    const updatedCompanyBillingDetails = CompanyBillingDetails.fromJSON(response);
    this.setIsUpdating(false);
    return updatedCompanyBillingDetails;
  }
}

export default CompanyBillingDetailsRepository;
